<div class="row c-form--d c-form__section">
  <div class="ml-10 mr-5">
    <span i18n="@@common.add_free_parameters" class="font-headline-4">Add Free Parameters</span>
    <span
      class="c-modal__hint"
      p500UITooltip
      i18n-tooltipData="@@offer.url_params_add_custom_hint"
      tooltipData="Add custom parameters to the URL"
      >?</span
    >
  </div>
  <p500-ui-dropdown class="c-dropdown c-dropdown--list mt-1" position="right">
    <ng-template p500UIDropdownHeader let-isOpen="isOpen" let-toggle="toggle">
      <button p500-ui-circled-button size="small" color="primary" type="button" (click)="toggle()">
        <p500-ui-icon name="plus"></p500-ui-icon>
      </button>
    </ng-template>
    <ng-template p500UIDropdownBody>
      <button p500UIDropdownItem class="c-dropdown__item -button" (click)="addForm()" [disabled]="disabledFree">
        <span class="c-dropdown__item-text" i18n="@@common.free">Free</span>
      </button>
      <button p500UIDropdownItem class="c-dropdown__item -button c-dropdown__item-text" (click)="addForm('advertiser')">
        <span class="c-dropdown__item-text" i18n="@@common.advertiser">Advertiser</span>
      </button>
    </ng-template>
  </p500-ui-dropdown>
</div>
<ng-container *ngFor="let group of form.controls; index as i">
  <ng-container [formGroup]="group">
    <div class="c-form__section d-flex">
      <span class="fw-bold">
        {{ group.controls.title.value }}
      </span>
      <span class="text-color text-color--gray"> &nbsp;({{ 'free_' + (i + 1) }})&nbsp; </span>
      <span
        class="c-modal__hint mr-10"
        p500UITooltip
        i18n-tooltipData="@@common.click_for_description"
        tooltipData="Click for description"
        (click)="openTooltipModal(group.controls.type.value)"
        >?</span
      >
      <button p500-ui-confluent-button color="warn" size="small" type="button" i18n="@@common.remove" (click)="removeForm(i)">
        Remove
      </button>
    </div>
    <div class="c-form__section">
      <p500-ui-text-field formControlName="title"> </p500-ui-text-field>
    </div>
    <ng-container [ngSwitch]="group.controls.type.value">
      <!-- advertiser -->
      <ng-container *ngSwitchCase="'advertiser'">
        <div class="c-form__section">
          <gtd-text-with-hint
            [control]="group.controls.default_value"
            i18n-label="@@common.placeholder"
            label="Placeholder"
            placeholder="{advertiser_affiliate_external_id} "
            [hintModal]="true"
            [tooltipHint]="modalTooltipEnum.OFFER_URL_PARAMS_PLACEHOLDER"
          ></gtd-text-with-hint>
        </div>
      </ng-container>
      <!-- default -->
      <ng-container *ngSwitchDefault>
        <div class="c-form--d c-form__section d-flex">
          <span class="fw-bold mr-10" i18n="@@common.add_values"> Add Values </span>
          <button p500-ui-circled-button size="small" color="primary" type="button" (click)="addAvailableForm(i)">
            <p500-ui-icon name="plus"></p500-ui-icon>
          </button>
        </div>
        <ng-container *ngFor="let availableGroup of group.controls.available_values.controls; index as j">
          <ng-container [formGroup]="availableGroup">
            <div class="row">
              <div class="c-form__section col-6">
                <gtd-text-with-hint
                  [control]="availableGroup.controls.label"
                  label="Label"
                  i18n-label="@@common.label"
                  [hintModal]="true"
                  [tooltipHint]="MODAL_TOOLTIP_KEY_ENUM.OFFER_URL_PARAMS_LABEL"
                ></gtd-text-with-hint>
              </div>
              <div class="c-form__section col-6">
                <div class="d-flex">
                  <gtd-text-with-hint
                    [control]="availableGroup.controls.value"
                    label="Value"
                    i18n-label="@@common.value"
                    [hintModal]="true"
                    [tooltipHint]="MODAL_TOOLTIP_KEY_ENUM.OFFER_URL_PARAMS_VALUE"
                  ></gtd-text-with-hint>
                  <button
                    p500-ui-circled-button
                    size="small"
                    type="button"
                    color="warn"
                    class="ml-10 mb-6 align-self-end"
                    [transparent]="true"
                    (click)="removeAvailableForm(i, j)"
                  >
                    <p500-ui-icon name="close"></p500-ui-icon>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="c-form__section" [hidden]="!group.controls.available_values.controls.length">
          <p500-ui-select-field
            formControlName="default_value"
            [data]="group.availableValues"
            bindValue="value"
            bindLabel="label"
            i18n-label="@@common.default"
            label="Default"
            hint="Used as a default option, shown to affiliates"
            i18n-hint="@@offer.url_default_option"
          >
          </p500-ui-select-field>
        </div>
        <div class="c-form__section" [hidden]="!group.controls.available_values.controls.length">
          <gtd-select-with-hint
            [control]="group.controls.public_keys"
            [data]="group.availableValues"
            bindValue="value"
            bindLabel="label"
            i18n-label="@@common.public_keys"
            label="Public Keys"
            [multiple]="true"
            [clearable]="true"
            [hintModal]="true"
            [tooltipHint]="MODAL_TOOLTIP_KEY_ENUM.OFFER_URL_PARAMS_PUBLIC_KEYS"
          >
          </gtd-select-with-hint>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <div class="c-line--horizontal mt-22 mb-22" [hidden]="form.controls.length - 1 === i">
    <div class="c-line__line"></div>
  </div>
</ng-container>
